export default __webpack_public_path__ + "static/media/36I-103555_-17657_0.3084c747.jpg";